import React from 'react';
import PropTypes from 'prop-types';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import { MediaCard } from '@ps-design-system/components/MediaCard';

import { useUploadModal } from '../context/UploadModalContext';

const UploaderSortableMediaCard = ({ id, item }) => {
  const { openDeleteModal } = useUploadModal();

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    touchAction: 'none'
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <MediaCard
        imageUrl={item.imageUrl}
        altText={item.altText}
        onClose={() => openDeleteModal(item)}
        type={item.type}
      />
    </div>
  );
};

UploaderSortableMediaCard.propTypes = {
  id: PropTypes.string.isRequired,
  item: PropTypes.shape({
    imageUrl: PropTypes.string.isRequired,
    altText: PropTypes.string.isRequired,
    type: PropTypes.string
  }).isRequired
};

export default UploaderSortableMediaCard;
